import React from 'react';
import './Screenshots.css';

const Screenshots: React.FC = () => {
  return (
    <section className="screenshots section">
      <div className="container">
        <div className="screenshots-header">
          <h2>See ChoreTap in Action</h2>
          <p>Experience the intuitive design that makes chore management effortless for parents and fun for kids</p>
        </div>

        <div className="screenshots-grid">
          {/* Parent Dashboard */}
          <div className="screenshot-item">
            <div className="screenshot-mockup">
              <div className="mockup-frame">
                <img
                  src="/screenshots/parent-screenshot-1.jpg"
                  alt="Parent Dashboard showing active chores, pending approvals, and quick actions"
                  className="screenshot-image"
                />
              </div>
            </div>
            <h3>Parent Dashboard</h3>
            <p>Keep track of all family chores, approvals, and earnings in one place</p>
          </div>

          {/* Child View */}
          <div className="screenshot-item">
            <div className="screenshot-mockup">
              <div className="mockup-frame">
                <img
                  src="/screenshots/child-screenshot-1.jpg"
                  alt="Child view showing available chores with payment amounts"
                  className="screenshot-image"
                />
              </div>
            </div>
            <h3>Kid-Friendly Interface</h3>
            <p>Simple, colorful design that kids love to use and understand</p>
          </div>

          {/* Additional Screenshot - Using child screenshot again for now */}
          {/*<div className="screenshot-item">*/}
          {/*  <div className="screenshot-mockup">*/}
          {/*    <div className="mockup-frame">*/}
          {/*      <img*/}
          {/*        src="/screenshots/child-screenshot-1.jpg"*/}
          {/*        alt="Earnings tracking and chore management interface"*/}
          {/*        className="screenshot-image"*/}
          {/*      />*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*  <h3>Track Progress</h3>*/}
          {/*  <p>Visual progress indicators and clear status updates keep everyone informed</p>*/}
          {/*</div>*/}
        </div>
      </div>
    </section>
  );
};

export default Screenshots;
